import script from './checkbox-group.vue_vue_type_script_lang.mjs';
export { default } from './checkbox-group.vue_vue_type_script_lang.mjs';
import { render } from './checkbox-group.vue_vue_type_template_id_9944d4d2_lang.mjs';

script.render = render;
script.__file = "packages/components/checkbox/src/checkbox-group.vue";
//# sourceMappingURL=checkbox-group.mjs.map
